import QXWidget from "./base";

const widget = new QXWidget(window.qxOptions);
widget.load();
